/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeManifest } from '@/styles/manifest';
import { IntertoysTheme } from './Intertoys/theme';

export const themeManifestCustom: ThemeManifest = {
	defaultTheme: 'Intertoys',
	themes: {
		Intertoys: IntertoysTheme
	},
};